module.exports = __webpack_public_path__ + "static/media/r368.a7dc2c3d.jpg";